<script>
    import {Route, Link} from './router';
    import app from "./stores/app";
    import user from './stores/user';
    import app_alert from "./stores/alerts";
    import {getClientCredits} from "./requests";
    import Initialize from './Initialize.svelte';
    import Login from './Login.svelte';
    import UserAccount from './UserAccount.svelte';
    import Loader from './Loader.svelte';
    import LeftMenu from './LeftMenu.svelte';
    import MessageNew from './MessageNew.svelte';
    import MessagesPending from './MessagesPending.svelte';
    import MessagesSent from './MessagesSent.svelte';
    import Confirm from "./AppAlert.svelte";
    import GroupEdit from './GroupEdit.svelte';
    import MemberEdit from './members/MemberEdit.svelte';
    import Clients from './Clients.svelte';
    import ClientEdit from './ClientEdit.svelte';
    import ClientCreditsHistory from './ClientCreditsHistory.svelte';
    import CreditsHistory from "./CreditsHistory.svelte";
    import ErrorMessage from './ErrorMessage.svelte';
    import SuccessMessage from './SuccessMessage.svelte';

    let initialized = false;
    let menuCollapsed = true; // main menu collapse & expand for mobiles


    const appInitialized = () => {
        initialized = true;
    }

    const showUserCredits = async () => {
        const [err, res] = await getClientCredits();
        if (err) {
            app_alert.show('error', err);
            return;
        }
        if (res) {
            user.updateCredits(res);
            app_alert.show('alert', "Έχετε " + res + " διαθέσημες μονάδες.");
        }
    }

    window.addEventListener('resize', function (event) {
        app.windowResize();
    });
    app.windowResize();

</script>

{#if initialized}
    {#if (!$user.id) }
        <Login/>
    {:else}
        <Route match="app">
            <header class="header fixed-top clearfix">
                <!--logo start-->
                <div class="brand" on:click="{ () => menuCollapsed = false }">
                    <div class="logo">
                        <img src="/assets/images/logo.png" alt="">
                    </div>
                </div>
                <!--logo end-->
                <div class="nav notify-row">
                    <ul class="nav top-menu">
                        <li>
                        <span class="menu-item smooth-trans" title="Διαθέσημες μονάδες" on:click="{ showUserCredits }">
                            <span class="icon"><i class="fa fa-battery"></i></span>
                            <span class="badge bg-important">{ $user.credits }</span>
                        </span>
                        </li>
                        <li class="hidden-lg hidden-md">
                        <span class="menu-item smooth-trans" on:click="{ () => menuCollapsed = false }">
                            <span class="icon"><i class="fa fa-bars"></i></span>
                        </span>
                        </li>
                    </ul>
                </div>
            </header>

            <LeftMenu collapsed="{ menuCollapsed }" callback="{ () => menuCollapsed = true }"/>

            <div id="main-content">
                <div class="wrapper">

                    <Route match="/">
                        <MessageNew/>
                    </Route>
                    <Route match="resendmessage">
                        <Route match="*" let:router>
                            <!--{ JSON.stringify(router) }-->
                            <MessageNew sms_id="{ router.wildcard[0] || 0 }"/>
                        </Route>
                    </Route>

                    <Route match="messagespending">
                        <Route exact>
                            <MessagesPending/>
                        </Route>
                    </Route>

                    <Route match="messagessent">
                        <Route match="*" let:router>
                            <!--{ JSON.stringify(router) }-->
                            <MessagesSent page="{ router.wildcard[0] || 1 }"/>
                        </Route>
                        <Route exact>
                            <MessagesSent/>
                        </Route>
                    </Route>

                    <Route match="clients">
                        <Route exact>
                            <Clients/>
                        </Route>
                    </Route>

                    <Route match="credits_history">
                        <Route exact>
                            <CreditsHistory/>
                        </Route>
                    </Route>

                    <Route match="myaccount">
                        <UserAccount/>
                    </Route>

                </div> <!-- wrapper -->
            </div>

            <GroupEdit/>
            <MemberEdit/>
            <ClientEdit/>
            <ClientCreditsHistory/>
        </Route>
    {/if}
{:else}
    <Initialize callback="{ appInitialized }"/>
{/if}

<ErrorMessage/>
<SuccessMessage/>
<Confirm/>
<Loader/>

